// extracted by mini-css-extract-plugin
module.exports = {"menu":"deckButton_menu__oxtd3","trigger":"deckButton_trigger__F4Gez"};